<template v-cloak> 
    <div class="pt450" id="pt450">
        <loading :active.sync="isLoading" 
            :can-cancel="false"
            :background-color="'transparent'">
        </loading>
        <div class="inputCondition">
            <!--マイページタイトル-->
            <h2>{{$t('common.labels.titleHeaderOrder')}}</h2>
            <br>
            <div class="orderHis">
                <!--購入履歴タイトル-->
                <div class="pt450-itemTitle">
                    <h3>{{$t('pt450.labels.title')}}</h3>
                </div>
                <!--エラーメッセージ表示 -->
                <div class="errorMessage">
                    <message :listMess="listMessValid" :mapMsg="mapMessValid" :idScreen="'PT450OrderHisOutput'"/>
                </div>
                <div>
                    <div class="input">
                        <div class="eigyokyoNoInfo1 mt-3">{{$t('pt450.labels.info')}}</div>
                    </div>
                    <br>
                    <select v-model="reqModel.csmNo" name="csmNo" id="_csmNo">
                        <option disabled value="undefined">{{$t('pt450.labels.selectDefault')}}</option>
                        <option v-for="csmNo in pt450Init.csmList" :key="csmNo.TDK_NO" :value="csmNo.TDK_NO" >
                            {{csmNo.TDK_NM}}
                        </option>
                    </select>
                    <input id="chioce-button" @click="okuriChoice(reqModel.csmNo)" :value="$t('pt450.buttons.choice')" type="button">
                    <br>
                </div>
                <br>
                <div class="pt450-link" v-if="isLinkShow" v-for="orderHis in pt450Init.orderHistList" :key="orderHis.NO_SORT">
                    <!--購入履歴リスト-->
                    <img class="icon_head" src="../img/icons/demo/output-pdf.png">
                    <a class="output-href" href="javascript:void(0)" @click="doDownloadPdf(reqModel.csmNo,orderHis.NO_SORT,'335')">{{orderHis.ORDER_HIS_TITLE}}</a>                
                </div>
                <div class="pt450-link" v-if="isLinkShow">
                    <!--届先一覧-->
                    <img class="icon_head" src="../img/icons/demo/output-pdf.png">
                    <a class="output-href" href="javascript:void(0)" @click="doDownloadPdf(reqModel.csmNo,'','336')">{{$t('pt450.buttons.tdkList')}}</a>                
                </div>   
            </div>
        </div> 
         <!-- modal confirm area -->
        <alert-confirm
            v-if="isModalShow"
            :msgConfirm="msgConfirm"
            :isButtonCancel="false"
            :okAction="okAction"
        >
        </alert-confirm> 
    </div>
</template>
<script>

/* 
* Import libs and componnents
*/
import common from "assets/js/common";
import Loading from 'vue-loading-overlay';
import axios from "assets/js/request";
import InputCheck from 'components/InputCheck';
import InputNumber from 'components/InputNumber';
import AlertConfirm from 'components/AlertConfirm';
import Message from 'components/MessageEcSite';
import SiteConstants from 'assets/const/SiteConstants.json';
import Breadcrumb from "../commonParts/Breadcrumb.vue";
export default {
    /* 
    * Name of component
    */
    name: "PT450OrderHisOutput",

    /*
    * Declare props
    */
    props: {
        ptInitData: {
            type: Object,
            default: null,
        }
    },

    /*
    * Declare components
    */
    components:{
            Loading,
            InputCheck,
            InputNumber,
            AlertConfirm,
            Message,
            Breadcrumb
        },
    data() {
        return {
            isDisplay: false,
            noResult: false,
            rowIndex: null,
            isPagingDisplay:true,
            isLoading: false,
            siteFlg : null,
            isTuisekiLinkShow: false,
            isModalRyosyusyo: false,
            isModalRyosyusyoError: false,
            isModalShow: false,
            isLinkShow: false,
            PT450OrderHisOutput:'pt450',
            printHisList: [],
            msgConfirm:'',
            reqModel:{
            },
            pt450Init: {
            },
            SiteConstants: SiteConstants,
            iSearch:false,
            // for validate
            listIdErr:[],
            listMessValid:[],
            mapMessValid:[]
        }
    },
    /*
    * 初期表示
    */
    mounted() {
        // Call API doInit
        var _this = this;
        _this.site = _this.$router.history.current.fullPath.split("/")[1];
        _this.isLoading = true;
        _this.pt450Init = _this.ptInitData;
        if (_this.ptInitData){
            if(_this.ptInitData.isLogin == false) {
                _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: { pageNo: 18}});
            }else{
                axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT450 + _this.$UrlConstants.DO_INIT, _this.reqModel).then(function(response) {
                    _this.pt450Init.csmList = response.data.csmList;
                    _this.pt450Init.orderHistList = response.data.orderHistList;
                }).catch(function(error) {
                    common.errorAPI(error);
                });
            }
        }
        _this.isLoading = false;
    },
    /*
    * メソッド
    */
    methods: {
        okuriChoice: function(csmNo) {
            var _this = this;
            _this.listMessValid = [];
            _this.mapMessValid = [];
            _this.isLoading = true;
            if(csmNo == undefined) {
                _this.msgConfirm = _this.$i18n.t('pt450.messages.msg');
                _this.isModalShow = true;
                //return;
            } else {
                _this.isModalShow = false;
                _this.isLinkShow = true;
            }
           _this.isLoading = false;
        },
        okAction:function(){
            var _this = this;
            _this.isModalShow = false;
        },
        /*
        * ダウンロード pdf
        */
        doDownloadPdf: function(csmNo,orderHisNo,printYoutoKbn) {
            var _this = this;
            common.clearMessageEcSite(_this.listIdErr, _this.PT450OrderHisOutput);
            _this.isLoading = true;

            _this.printData = {};
            _this.printData.csmNo = csmNo;
            _this.printData.orderHisNo = orderHisNo;
            _this.printData.printYoutoKbn = printYoutoKbn;

            let appPath = process.env.VUE_APP_PUBLIC_PATH;
            if(appPath.endsWith('/')) {
                appPath = appPath.slice(0, -1);
            }
            if(appPath.startsWith('/')) {
                appPath = appPath.slice(1);
            }
            _this.printData.wfrBasePath = window.location.protocol + "//" + window.location.host + "/" +appPath;
            
            _this.$emit("event-loading", true);
            _this.listMessValid = [];
            _this.mapMessValid = [];
            axios({url: _this.$UrlConstants.ECSITE + _this.$UrlConstants.PT450 + _this.$UrlConstants.DO_PRINT, method: "POST", responseType: "blob", data: _this.printData}).then(function(response) {
                var fileName = "";
                var disposition = response.headers["content-disposition"];
                if (disposition && disposition.indexOf("attachment") !== -1) {
                var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                var matches = filenameRegex.exec(disposition);
                if (matches != null && matches[1]) {
                    fileName = matches[1].replace(/['"]/g, "");
                }
                }
                if (/*@cc_on!@*/ false || !!document.documentMode) {
                window.navigator.msSaveBlob(new Blob([response.data]), fileName);
                } else {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", fileName);
                document.body.appendChild(link);
                link.click();
                }
                _this.search();
                _this.$emit("event-loading", false);
            }).catch(async function(error) {
                if(error != null && error != undefined){
                    _this.isModalShow = false;
                    if(error.response != null && error.response != undefined){
                        if(406 == error.response.status){
                            if (error.request.responseType === "blob") {
                                let responseObj = await error.response.data.text();
                                error.response.data = JSON.parse(responseObj);
                            }
                            var resultValid = common.excuteValidationEcSite(error, 'PT450OrderHisOutput');
                            if(resultValid){
                                _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                _this.listMessValid = resultValid.msgList;
                                _this.mapMessValid = resultValid.mapMsg;
                            }
                            common.scrollTop();
                        }else{
                            common.errorAPI(error);
                        }
                    }
                }
                _this.$emit("event-loading", false);
                _this.isLoading = false;
            });
        },
        /*
        * Function download
        * ダウンロード
        */
        download: function(){
            var _this = this;
            common.clearMessage(_this.listIdErr);
            console.log(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT450 + _this.$UrlConstants.DO_PRINT);
            //Call API to download files
            _this.isLoading = true;
            axios({
                    url: _this.$UrlConstants.ECSITE + _this.$UrlConstants.PT450 + _this.$UrlConstants.DO_PRINT,
                    method: 'POST',
                    responseType: 'blob', // important
                    data: _this.reqModel
                }
            )
            .then(function(response){
                console.log(response);
                var fileName = "";
                var disposition = response.headers['content-disposition'];
                if (disposition && disposition.indexOf('attachment') !== -1) {
                    var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                    var matches = filenameRegex.exec(disposition);
                    if (matches != null && matches[1]) { 
                        fileName = matches[1].replace(/['"]/g, '');
                    }
                }
                if(/*@cc_on!@*/false || !!document.documentMode)
                {
                    window.navigator.msSaveBlob(new Blob([response.data]),fileName);
                }else{
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', fileName);
                    document.body.appendChild(link);
                    link.click();
                }
                _this.isLoading = false;
                common.clearMessage(_this.listIdErr);
            })
            .catch(function(error){
                console.log(error);
                var reader = new FileReader();
                reader.onload = function() {
                    if(error != null && error != undefined){
                        if(error.response != null && error.response != undefined){
                            if(405 == error.response.status){
                                var readerResult=JSON.parse(reader.result);
                                error.response.data.errorList=readerResult.errorList;
                                common.excuteValidation(error);
                            }else{
                                common.errorAPI(reader.result);
                            }
                        }
                    }
                }
                reader.readAsText(error.response.data);
                _this.isLoading = false;
            });
        },
    }
}
</script>
